import { render, staticRenderFns } from "./SectionChangesIndicator.vue?vue&type=template&id=131ef5fa&"
import script from "./SectionChangesIndicator.vue?vue&type=script&lang=js&"
export * from "./SectionChangesIndicator.vue?vue&type=script&lang=js&"
import style0 from "./SectionChangesIndicator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports